// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1dSDc","load8":"Spinner_load8__1cnEc"};